import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "row mb-3" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h3", { class: "h3-responsive col-12 px-2 mb-3 mt-0 mt-sm-3" }, "Wähle den Zustand:", -1);
const _hoisted_3 = ["onMouseover", "onClick"];
const _hoisted_4 = { class: "row mx-n2 pt-3 mb-4 px-2 font6-responsive bg-brand_beige_light" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions_and_texts, (condition) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "col-6 px-2 pb-2",
                    key: condition.id
                }, [
                    _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["buttonBase buttonBlueInverted font7-responsive w-100 [ JS_conditionButton ]", `condition_${condition.id}`]),
                        onMouseover: ($event) => (_ctx.buttonFocused(condition.id)),
                        onMouseout: _cache[0] || (_cache[0] = ($event) => (_ctx.buttonFocused(null))),
                        onClick: ($event) => (_ctx.emitProductCondition(condition.id))
                    }, _toDisplayString(condition.label), 43, _hoisted_3)
                ]));
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions_and_texts, (infos) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-6 col-12",
                    key: infos.id
                }, [
                    _createElementVNode("strong", null, _toDisplayString(infos.label) + ":", 1),
                    _createElementVNode("p", {
                        class: _normalizeClass({ strong: infos.id === _ctx.focused_condition_id })
                    }, _toDisplayString(infos.text), 3)
                ]));
            }), 128))
        ])
    ], 512)), [
        [_vShow, _ctx.current_step === 1]
    ]);
}
